export { default } from './LeaveClass'
